
import { mapState } from 'vuex'
import CategoryLevel1 from '../../components/category/CategoryLevel1'
import CategoryLevel3 from '../../components/category/CategoryLevel3'
import { removeVietnameseTones, textToSlug } from '../../utils/utils'
import {
  CATEGORY_GET_DETAIL,
  CATEGORY_GET_LIST_PRODUCT,
  INDEX_SET_LOADING,
  SET_ADD_FILTER
} from '../../store/store.const'
import LastSeen from '../../components/home/LastSeen'
import { getCategorySortOptions, PRODUCT_SORT } from '../../constants/product-sort'

export default {
  name: 'CategoryDetailCommon',
  components: { CategoryLevel1, CategoryLevel3, LastSeen },
  async asyncData({ app, store, route, redirect }) {
    try {
      const listFilterAdvance = []
      // let listDataFilterAdvance = []
      let listProperties = null
      const list = {}
      const listDataFilter = {
        category: {
          current: {},
          children: [],
          parent: {
            id: '',
            slug: '',
            link: '',
            name: '',
            image: ''
          }
        }
      }
      const dataUrl = route.params.slug.split('.')
      const categoryData = (await store.dispatch(CATEGORY_GET_DETAIL, { id: dataUrl[1], slug: dataUrl[0] })).data
      let data = {}
      data = categoryData?.category
      data.link = '/category/' + (data.slug ? data.slug : textToSlug(removeVietnameseTones(data.name))) + '.' + data.id
      const breadcrumbs = []
      categoryData.breadcrumbs.forEach(cat => {
        breadcrumbs.push({
          id: cat.id,
          name: cat.name,
          link: '/category/' + (cat.slug ? cat.slug : textToSlug(removeVietnameseTones(cat.name))) + '.' + cat.id,
          image: cat.image_url,
          image_thumb_url: cat.image_thumb_url
        })
      })
      data.breadcrumbs = breadcrumbs
      let children = []
      if (categoryData.category_level === 3) {
        const dataParent = {}
        if (data.breadcrumbs.length === 3) {
          dataParent.current = categoryData.category_tree[0].children[0]
          const childrendata = []
          dataParent.current.children.forEach(cat => {
            childrendata.push({
              id: cat.id,
              name: cat.name,
              link: '/category/' + (cat.slug ? cat.slug : textToSlug(removeVietnameseTones(cat.name))) + '.' + cat.id,
              image: cat.image_url,
              image_thumb_url: cat.image_thumb_url
            })
          })
          dataParent.children = childrendata
          dataParent.parent = categoryData.category_tree[0]
        } else {
          const childrendata = []
          categoryData.category_tree[0].children.forEach(cat => {
            childrendata.push({
              id: cat.id,
              name: cat.name,
              link: '/category/' + (cat.slug ? cat.slug : textToSlug(removeVietnameseTones(cat.name))) + '.' + cat.id,
              image: cat.image_url,
              image_thumb_url: cat.image_thumb_url
            })
          })
          dataParent.children = childrendata
          dataParent.parent = categoryData.category_tree[0]
        }
        listDataFilter.category = dataParent
        listDataFilter.branch = categoryData.shops.map(shop => {
          return { ...shop, value: shop.name }
        })
        listDataFilter.price = categoryData.price_range
        categoryData.properties.forEach(property => {
          list[property.key] = property
          listFilterAdvance.push(property.key)
        })
        listProperties = categoryData.properties
      } else {
        const childrendata = []
        categoryData.children.forEach(cat => {
          childrendata.push({
            id: cat.id,
            name: cat.name,
            link: '/category/' + (cat.slug ? cat.slug : textToSlug(removeVietnameseTones(cat.name))) + '.' + cat.id,
            image: cat.image_url,
            image_thumb_url: cat.image_thumb_url
          })
        })
        children = childrendata
      }
      data.children = children
      const category_level = categoryData.category_level
      const defaultTitle = data.name + ' - ' + app.i18n.t('home.title')
      const scripts = {}
      scripts.title = data?.meta_title ?? defaultTitle
      scripts.meta = [
        { hid: 'title', name: 'title', content: data?.meta_title ?? defaultTitle },
        { hid: 'description', name: 'description', content: data.meta_description ?? '' },
        { hid: 'url', name: 'url', content: route.path },
        { hid: 'keywords', name: 'keywords', content: data.meta_keywords ?? '' },
        { hid: 'twitter:card', name: 'twitter:card', content: 'website' },
        { hid: 'twitter:title', name: 'twitter:title', content: data?.meta_title ?? defaultTitle },
        { hid: 'twitter:description', name: 'twitter:description', content: data.meta_description ?? '' },
        { hid: 'twitter:image', name: 'twitter:image', content: data.meta_image ?? '' },
        { hid: 'twitter:keywords', name: 'twitter:keywords', content: data.meta_keywords ?? '' },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:title', property: 'og:title', content: data?.meta_title ?? defaultTitle },
        { hid: 'og:description', property: 'og:description', content: data.meta_description ?? '' },
        { hid: 'og:image', property: 'og:image', content: data.meta_image ?? '' },
        { hid: 'og:keywords', property: 'og:keywords', content: data.meta_keywords ?? '' }
      ]
      if (data.canonical !== null) {
        scripts.link = [
          { hid: 'canonical', rel: 'canonical', href: data.canonical }
        ]
      }
      return {
        category: data,
        listDataFilterAdvance: list,
        category_level,
        list,
        scripts,
        listDataFilter,
        listProperties,
        listFilterAdvance
      }
    } catch (e) {
      console.error(e)
      redirect(301, '/')
    }
  },
  data() {
    return {
      slug: this.$route.params.slug,
      listProperties: null,
      scripts: {},
      category: {
        id: '',
        slug: 'phong-khach',
        title: 'Phòng khách',
        image: '',
        link: '/category/phong-khach',
        child: [],
        breadcrumbs: []
      },
      category_level: 1,
      products: [],
      list: [],
      total: 0,
      type_sort: PRODUCT_SORT.POPULAR,
      page: 1,
      per_page: 23,
      last_page: 1,
      querySearch: '',
      listFilter: [
        'category',
        'price',
        'price_range',
        'branch',
        'rating'
      ],
      listDataFilter: {
        category: {
          current: {},
          children: [],
          parent: {
            id: '',
            slug: '',
            link: '',
            name: '',
            image: ''
          }
        }
      },
      listFilterAdvance: [],
      listDataFilterAdvance: {},
      nextPage: true,
      dataShowMore: '',
      toggleShowMore: true
    }
  },
  head() {
    return this.scripts
  },
  computed: {
    ...mapState('filter', {
      addFilter: state => state.addFilter
    }),
    list_sort() {
      return getCategorySortOptions(key => this.$t(key))
    },
    metaPixelScripts() {
      const scripts = {}
      if (!process.browser) return scripts
      const defaultTitle = this.category.name + ' - ' + this.$t('home.title')
      scripts.title = this.category?.meta_title ?? defaultTitle
      scripts.meta = [
        { hid: 'title', name: 'title', content: this.category?.meta_title ?? defaultTitle },
        { hid: 'description', name: 'description', content: this.category.meta_description },
        { hid: 'url', name: 'url', content: this.$route.path },
        { hid: 'keywords', name: 'keywords', content: this.category.meta_keywords ?? '' },
        { hid: 'twitter:card', name: 'twitter:card', content: 'website' },
        { hid: 'twitter:title', name: 'twitter:title', content: this.category?.meta_title ?? defaultTitle },
        { hid: 'twitter:description', name: 'twitter:description', content: this.category.meta_description ?? '' },
        { hid: 'twitter:image', name: 'twitter:image', content: this.category.meta_image ?? '' },
        { hid: 'twitter:keywords', name: 'twitter:keywords', content: this.category.meta_keywords ?? '' },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:title', property: 'og:title', content: this.category?.meta_title ?? defaultTitle },
        { hid: 'og:description', property: 'og:description', content: this.category.meta_description ?? '' },
        { hid: 'og:image', property: 'og:image', content: this.category.meta_image ?? '' },
        { hid: 'og:keywords', property: 'og:keywords', content: this.category.meta_keywords ?? '' }
      ]
      if (this.category.canonical !== null) {
        scripts.link = [
          { hid: 'canonical', rel: 'canonical', href: this.category.canonical }
        ]
      }
      return scripts
    }
  },
  watch: {
    querySearch() {
      this.getListProduct(this.buildCategoryProductFilters())
    }
  },
  beforeMount() {
    if (!this.listDataFilterAdvance.length && this.category_level === 3) {
      this.listProperties.forEach(property => {
        this.listDataFilterAdvance[property.key] = property
      })
    }
  },
  async mounted() {
    console.log(this.listFilterAdvance, this.listProperties, this.listDataFilterAdvance, this.category)
    this.convertDataUrl()
    if ([3].includes(this.category_level)) {
      await this.getListProduct(this.buildCategoryProductFilters(this.$route.query))
    }
  },
  methods: {
    hasOrderByValue(value) {
      return value !== undefined && value !== null && value !== ''
    },
    normalizeOrderBy(value) {
      const orderBy = Number(value)
      return this.hasOrderByValue(value) && Number.isFinite(orderBy) ? orderBy : PRODUCT_SORT.POPULAR
    },
    buildCategoryProductFilters(filters = {}) {
      return {
        ...filters,
        page: filters.page ? Number(filters.page) : (this.page || 1),
        per_page: filters.per_page ? Number(filters.per_page) : this.per_page,
        order_by: this.normalizeOrderBy(filters.order_by ?? this.type_sort)
      }
    },
    syncCategoryQuery() {
      const query = {
        ...this.$route.query,
        order_by: this.type_sort
      }

      this.$router.replace({ query }).catch(() => {})
    },
    changeToLink(link) {
      this.$router.push(link)
    },
    async fetchDataCategory() {
      try {
        await this.$store.commit(INDEX_SET_LOADING, true)
        const data = this.slug.split('.')
        const category = await this.$store.dispatch(CATEGORY_GET_DETAIL, { id: data[1], slug: data[0] })
        this.category = this.convertData(category.data)
        this.dataShowMore = this.category.short_description
        this.category_level = category.data.category_level
        document.title = this.category.name + ' - ' + this.$t('home.title')
      } catch (e) {
        console.log(e)
      }
      await this.$store.commit(INDEX_SET_LOADING, false)
    },
    async getListProduct(val) {
      try {
        await this.$store.commit(INDEX_SET_LOADING, true)
        const dataId = this.slug.split('.')
        const filters = this.buildCategoryProductFilters(val)
        this.type_sort = filters.order_by
        const products = await this.$store.dispatch(CATEGORY_GET_LIST_PRODUCT, { id: dataId[1], filters })
        if (!this.$device.isMobile) {
          if (this.products.length) this.products.push(...products.data.data)
          else this.products = products.data.data
          this.page = products.data.current_page
          this.last_page = products.data.total_page
          this.total = products.data.total
        } else {
          if (this.products.length) this.products.push(...products.data.data)
          else this.products = products.data.data
          this.page = products.data.current_page
          this.last_page = products.data.total_page
          this.total = products.data.total
        }
      } catch (e) {
        console.log(e)
      }
      await this.$store.commit(INDEX_SET_LOADING, false)
    },
    convertData(category) {
      let data = {}
      data = category.category
      data.link = '/category/' + textToSlug(removeVietnameseTones(data.name)) + '.' + data.id
      const breadcrumbs = []
      category.breadcrumbs.forEach(cat => {
        breadcrumbs.push({
          id: cat.id,
          name: cat.name,
          link: '/category/' + textToSlug(removeVietnameseTones(cat.name)) + '.' + cat.id,
          image: cat.image_url,
          image_thumb_url: cat.image_thumb_url
        })
      })
      data.breadcrumbs = breadcrumbs
      let children = []
      if (category.category_level === 3) {
        const dataParent = {}
        if (data.breadcrumbs.length === 3) {
          dataParent.current = category.category_tree[0].children[0]
          dataParent.children = this.convertDataChildren(dataParent.current)
          dataParent.parent = category.category_tree[0]
        } else {
          dataParent.children = this.convertDataChildren(category.category_tree[0])
          dataParent.parent = category.category_tree[0]
        }
        this.listDataFilter.category = dataParent
        this.listDataFilter.branch = category.shops.map(shop => {
          return { ...shop, value: shop.name }
        })
        this.listDataFilter.price = category.price_range
        category.properties.forEach(property => {
          this.listDataFilterAdvance[property.key] = property
          this.listFilterAdvance.push(property.key)
        })
      } else {
        children = this.convertDataChildren(category)
      }
      data.children = children
      return data
    },
    convertDataChildren(category) {
      const children = []
      category.children.forEach(cat => {
        children.push({
          id: cat.id,
          name: cat.name,
          link: '/category/' + textToSlug(removeVietnameseTones(cat.name)) + '.' + cat.id,
          image: cat.image_url,
          image_thumb_url: cat.image_thumb_url
        })
      })
      return children
    },
    convertDataUrl() {
      const query = this.$route.query
      this.type_sort = this.normalizeOrderBy(query.order_by)
      for (const [key] of Object.entries(query)) {
        if (key === 'page') {
          this.page = Number(query[key])
        }
      }
      if (!this.hasOrderByValue(query.order_by)) {
        this.syncCategoryQuery()
      }
      this.$store.commit(SET_ADD_FILTER, !this.addFilter)
    },
    async loadProducts(val) {
      if (this.$device.isMobile) this.nextPage = false
      this.products = []
      this.page = 1
      await this.getListProduct(this.buildCategoryProductFilters({ ...val, page: 1 }))
      if (this.$device.isMobile) this.nextPage = true
    },
    toggleShowMoreFn() {
      this.toggleShowMore = !this.toggleShowMore
    },
    loadMoreProduct(val) {
      this.getListProduct(this.buildCategoryProductFilters(val))
    }
  }
}
